(function () {
  /**
   * Fix for media-gallery init race condition with vertical-thumbs CSS.
   * When pdp-vertical-thumbs.css makes <media-gallery> a flex container,
   * the layout is computed asynchronously. media-gallery.js's connectedCallback
   * runs before layout is solved, so setVisibleItems() filters out items
   * with clientWidth=0 → visibleItems empty → initGallery early-returns →
   * thumb click handlers never attached.
   *
   * This script re-triggers initGallery() AFTER layout is stable.
   */
  function reinitIfNeeded() {
    var galleries = document.querySelectorAll('media-gallery[data-vertical-thumbs-desktop]');
    galleries.forEach(function (gallery) {
      if (typeof gallery.initGallery !== 'function') return;
      if (gallery.dataset.verticalThumbsReinit === 'true') return;

      // Probe: are visible items correctly populated?
      var hasInit =
        Array.isArray(gallery.visibleItems) &&
        gallery.visibleItems.length > 1 &&
        typeof gallery.viewerItemOffset === 'number' &&
        gallery.viewerItemOffset > 0;

      if (!hasInit) {
        // Re-trigger init now that layout is stable
        gallery.initGallery();
      }

      gallery.dataset.verticalThumbsReinit = 'true';
    });
  }

  // Defer until next animation frame so layout is fully resolved
  function scheduleReinit() {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(function () {
        requestAnimationFrame(reinitIfNeeded);
      });
    } else {
      setTimeout(reinitIfNeeded, 50);
    }
  }

  if (document.readyState === 'complete') {
    scheduleReinit();
  } else {
    window.addEventListener('load', scheduleReinit);
  }

  // Safety net: also try after 500ms in case load event already fired
  // before this script was parsed
  setTimeout(reinitIfNeeded, 500);
})();
